import MetaBase from "@dojo/framework/core/meta/Base";

/**
 * Meta to know whether shape has text or not
 */
class IsShapeHasText extends MetaBase {
	/**
   * Get information about shape has text or not for give key
   * @param key key to node
   */
	public get(key: string) {
		const node = this.getNode(key) as HTMLElement;
		const textValue = ((node && node.innerText) || "").replace(/\n/ig, "")
			.trim();
		return textValue !== "";
	}
}

export default IsShapeHasText;
